import React, { useCallback, useEffect, useState } from 'react';
import next from '../../../assets/sso/next.svg';
import time from '../../../assets/sso/time.svg';
import see from '../../../assets/sso/see.svg';
import noPublication from '../../../assets/phone_no_content.svg';
import { format } from 'date-fns';
import { DATE_FORMAT_ISO_DAY } from '../../../constants/dateFormat';
import axios from 'axios';
import mediaUrl from '../../../service/mediaUrl';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import PublicationImageWithLogo from '../../../components/PublicationImageWithLogo';

interface Publication {
    media?: string;
    extension?: string;
    title: string;
    content: string;
    status: string;
    createdAt: string;
    publicationDate: string;
    createdByAdmin: string;
    createdByUser: string;
    id: number;
    isGlobal?: boolean;
}
const NextPublication: React.FC = () => {
    const [publication, setPublication] = useState<Publication[]>([]);
    const userId = useSelector((state: RootState) => state.user.id);
    const isSsoUser = useSelector((state: RootState) => state.user.isSsoUser);
    const today = new Date();
    const formattedDate = format(today, DATE_FORMAT_ISO_DAY);

    const nextPublication = useCallback(async () => {
        let url =
            `/api/publications-all-accessible-for-` +
            (isSsoUser ? `user/${userId}` : 'admin') +
            `?limit=1&status=1&pubDateSup=${formattedDate}&pubDate=asc`;
        const response = await axios.get<Publication[]>(url);
        setPublication(response.data);
    }, [formattedDate, isSsoUser, userId]);

    const formatDate = (date: string): string => {
        const publiDate = new Date(date);
        return format(publiDate, 'dd/MM/yyyy');
    };

    const formatHour = (date: string): string => {
        const publiDate = new Date(date);
        return format(publiDate, 'HH:mm');
    };

    useEffect(() => {
        nextPublication();
    }, [nextPublication]);

    return (
        <div className="box-next flex flex-col h-full">
            <div className="flex items-center justify-start gap-2 w-full mb-4">
                <img className="h-[40px]" src={next} alt="archive icon" />
                <div
                    className={
                        'flex-1 justify-center text-neutral-900 font-semibold leading-normal ' +
                        (isSsoUser === false ? 'text-heavy' : 'text-medium')
                    }
                >
                    Publications à venir
                </div>
            </div>
            {publication.length > 0 ? (
                <>
                    <div className="flex-grow flex-shrink-0 h-[200px]">
                        <PublicationImageWithLogo
                            imageUrl={mediaUrl(publication[0])}
                            alt="illustration de la publication"
                            className="flex justify-center w-full rounded h-[160pxpx]"
                            isGlobal={publication[0].isGlobal}
                            showLogo={true}
                            extension={publication[0].extension}
                        />
                    </div>
                    <div className="flex flex-col pt-2.5 gap-2 flex-shrink-0">
                        <div className="text-medium-title font-medium text-dark-gray">
                            <div className="mt-1 line-clamp-2">{publication[0].title}</div>
                        </div>
                        <div className="text-base font-light text-gray-500 line-clamp-2">
                            {publication[0].content}
                        </div>
                    </div>
                    <div className="flex-shrink-0 mt-auto">
                        <div
                            className="w-full border my-4"
                            style={{ height: '1px', borderColor: 'rgba(228, 228, 228, 1)' }}
                        ></div>
                        <div className="flex items-center justify-between">
                            <span
                                className="flex items-center gap-[5px] py-[4px] px-[8px] rounded-[30px] text-medium-small font-medium text-gray"
                                style={{ backgroundColor: 'rgba(239, 239, 239, 1)' }}
                            >
                                <img src={time} alt="clock logo" />
                                {formatDate(publication[0].publicationDate) +
                                    ' | ' +
                                    formatHour(publication[0].publicationDate)}
                            </span>
                            <span className="flex items-center gap-[5px] py-[4px] px-[8px] rounded-[30px] text-medium-small font-medium text-gray">
                                <img src={see} alt="check logo" />
                                <Link to={`/show_publication/${publication[0].id}`}>
                                    Voir un aperçu
                                </Link>
                            </span>
                        </div>
                    </div>
                </>
            ) : (
                <div className="flex flex-col max-h-full flex-1 items-center justify-between gap-6">
                    <img
                        className="mt-6 w-3/5"
                        src={noPublication}
                        alt="no publication available"
                    />
                    <p className="mb-2">Aucune publication à venir !</p>
                </div>
            )}
        </div>
    );
};

export default NextPublication;
